"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A collection of details
 * @param {number} count the number of details returned
 * @param {string} lastKey the pagination key for the last item
 * @param {Array.<Detail>} type the details of the given type
 */
class Details {
    constructor(fields, type) {
        if (!fields) {
            return;
        }
        if (fields.count) {
            this.count = fields.count;
        }
        if (fields[type]) {
            this[type] = fields[type];
        }
        if (fields.lastKey) {
            this.lastKey = fields.lastKey;
        }
    }
}
exports.default = Details;
//# sourceMappingURL=Details.js.map